export enum AttachExistingVendorQuoteColId {
  CUSTOMER_CORPORATE_USER_NAME = 'customerCorporateUserName',
  CUSTOMER_PROJECT_NAME = 'customerProjectName',
  EXTERNAL_NUMBER = 'externalNumber',
  EXTERNAL_PROJECT_NAME = 'externalProjectName',
  ID = 'id',
  JOB_NAME = 'jobName',
  START_DATE = 'startDate',
  VALID_UNTIL = 'validUntil',
  VENDOR_CONTACT_GROUP_NAME = 'vendorContactGroupName',
  VENDOR_CONTACT_NAME = 'vendorContactName',
}
